import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'landing-page';

export const loadData = (params, search, config, preferredLanguage) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  const language = preferredLanguage || config?.localization?.language;
  return dispatch(fetchPageAssets(pageAsset, true, language));
};
